import * as routerNames from '@/services/router/router.names'

import CalendarScreen from '@/screens/calendar/calendar.vue'

export default [
  {
    path: '/:accountId/calendar/',
    name: routerNames.CALENDAR,
    component: CalendarScreen,
  },
]
